var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.0078125H512V341.992H0V-0.0078125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.0078125H513V113.992H0V-0.0078125Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 227.892H513V341.892H0V227.892ZM278.8 134.792C278.9 136.792 287.5 160.992 283.2 174.192C276.6 194.492 267.4 195.992 263.4 198.692V133.992L256.5 129.792L249.6 133.992V198.692C245.6 195.992 237.2 196.292 229.8 174.192C225.5 161.492 235.5 136.892 235.6 134.992C235.6 134.992 226.1 143.092 219.8 158.992C213.9 173.792 221.7 208.592 249.3 213.792C251.6 214.192 254 219.392 256.5 219.392C258.6 219.392 260.6 214.192 262.5 213.892C290.9 209.292 297.5 172.192 292.4 158.292C287 143.692 278.8 134.792 278.8 134.792Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M44.6 98.8926H66.9V123.293H44.6V98.8926ZM0 98.8926H22.3V123.293H0V98.8926ZM89.2 98.8926H111.5V123.293H89.2V98.8926ZM133.8 98.8926H156.1V123.293H133.8V98.8926ZM178.4 98.8926H200.7V123.293H178.4V98.8926ZM223 98.8926H245.3V123.293H223V98.8926ZM267.7 98.8926H290V123.293H267.7V98.8926ZM312.3 98.8926H334.6V123.293H312.3V98.8926ZM356.9 98.8926H379.2V123.293H356.9V98.8926ZM401.5 98.8926H423.8V123.293H401.5V98.8926ZM446.1 98.8926H468.4V123.293H446.1V98.8926ZM490.7 98.8926H513V123.293H490.7V98.8926ZM44.6 216.893H66.9V242.393H44.6V216.893ZM0 216.893H22.3V242.393H0V216.893ZM89.2 216.893H111.5V242.393H89.2V216.893ZM133.8 216.893H156.1V242.393H133.8V216.893ZM178.4 216.893H200.7V242.393H178.4V216.893ZM223 216.893H245.3V242.393H223V216.893ZM267.7 216.893H290V242.393H267.7V216.893ZM312.3 216.893H334.6V242.393H312.3V216.893ZM356.9 216.893H379.2V242.393H356.9V216.893ZM401.5 216.893H423.8V242.393H401.5V216.893ZM446.1 216.893H468.4V242.393H446.1V216.893ZM490.7 216.893H513V242.393H490.7V216.893Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_960"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.0078125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIr);
export default __webpack_public_path__ + "static/media/IR.58ce2129d8c48f5cdceba9d01b8dd5ed.svg";
export { ForwardRef as ReactComponent };